import { Table } from 'dexie';
import db, { Database } from '@/db';

// Define a mapping from key + value type
interface AppSettingsMap {
  myPlayers: boolean;
  accounts: string | null;
  lastSyncDate: string;
  lastOrdersSyncDate: string;
  // Add new settings here later
}

interface AppSetting<K extends keyof AppSettingsMap = keyof AppSettingsMap> {
  key: K;
  value: AppSettingsMap[K];
}

export type TABLE_TYPE = Table<AppSetting>;

export const TABLE = 'appSettings';
const SCHEMA = 'key';

class AppSettingsDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  async get(key: keyof AppSettingsMap): Promise<AppSetting | undefined> {
    return this.db[TABLE].get(key);
  }

  async getAll(): Promise<{ [K in keyof AppSettingsMap]?: AppSettingsMap[K] }> {
    const settings = await this.db[TABLE].toArray();
    return settings.reduce(
      (acc, row) => {
        acc[row.key as keyof AppSettingsMap] = row.value as any;
        return acc;
      },
      {} as { [K in keyof AppSettingsMap]?: AppSettingsMap[K] },
    );
  }

  async set<K extends keyof AppSettingsMap>(key: K, value: AppSettingsMap[K]): Promise<void> {
    await this.db[TABLE].put({ key, value });
  }

  async delete<K extends keyof AppSettingsMap>(key: K): Promise<void> {
    await this.db[TABLE].delete(key);
  }

  async list(): Promise<AppSetting[]> {
    return this.db[TABLE].toArray();
  }
}

export const AppSettingsDB = new AppSettingsDatabase(db);
